import React from 'react';
import ContentLoader from 'react-content-loader';

const RectangleSkeleton = ({ width, height }) => (
    <ContentLoader speed={2} width={width} height={height} backgroundColor="#c7c7c7" foregroundColor="#ecebeb">
        <rect x="0" y="0" rx="0" ry="0" width={String(width)} height={String(height)} />
    </ContentLoader>
);

RectangleSkeleton.displayName = 'RectangleSkeleton';
export default RectangleSkeleton;
